/**
 * Video.js plugin "a11yTooltips"
 *
 * The plugin adds tooltips to the player interface.
 *
 * @function a11yTooltips
 * @param
 */

const onFocusBlur = () => {
  const current = document.querySelector('.a11y-focus');
  if (current) {
    current.classList.remove('a11y-focus');
  }
};

const onKeyup = e => {
  onFocusBlur();
  setTimeout(() => {
    e.target.classList.add('a11y-focus');
  }, 1);
};

const pluginA11yTooltips = videojs => {
  videojs.registerPlugin('a11yTooltips', function (player) {
    player.ready(() => {
      player._customEvents = [];
      player.el_?.addEventListener('keyup', onKeyup);
      setTimeout(() => {
        player.el_.querySelectorAll('a[title], button[title]').forEach(el => {
          el.addEventListener('blur', onFocusBlur);
          player._customEvents.push(el);
        });
      }, 1);
    });
  });
};

export { pluginA11yTooltips };
